/**
 * Agent Booking Console - redirects to the main assisted booking page
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AgentBookingConsole = () => {
  const navigate = useNavigate();
  useEffect(() => { navigate("/admin/assisted-booking"); }, [navigate]);
  return <div className="min-h-screen bg-slate-900 flex items-center justify-center"><p className="text-white">Redirecting...</p></div>;
};

export default AgentBookingConsole;
